import { render } from "./TranslateProject.vue?vue&type=template&id=4edeafb8"
import script from "./TranslateProject.vue?vue&type=script&lang=js"
export * from "./TranslateProject.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__